import { Container } from '@algbra/ui/components/Grid/Grid'
import Whitespace from '@algbra/ui/components/Whitespace/Whitespace'
import { map } from 'rambdax'
import React from 'react'
import ZoneProductFeatureBlock, {
  ZoneProductFeature,
} from './ProductFeatureBlock'
import styles from './ProductFeatureBlockList.module.scss'

export type ZoneProductFeatureBlockListProps = {
  __typename: 'StrapiGQL_ComponentZonesProductFeatureBlockList'
  title: string
  features: ZoneProductFeature[]
}
export default function ZoneProductFeatureBlockList({
  features,
}: ZoneProductFeatureBlockListProps): JSX.Element {
  return (
    <Container className={styles.container}>
      {map(
        feature => (
          <ZoneProductFeatureBlock key={feature.id} feature={feature} />
        ),
        features
      )}
    </Container>
  )
}
